import { useRef, useState } from "react";
import { CloudUpload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../../ui/input";
import { formatApiError } from "../../../lib/api";
import { uploadMaterial } from "../../../lib/upload";

/** Caja de subida (PDF, video o imagen) usada por distribuidor y admin. */
export const UploadBox = ({ onUploaded, hint }) => {
  const fileRef = useRef(null);
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [progress, setProgress] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!file) return toast.error("Elige un archivo PDF, MP4 o imagen");
    setProgress(0);
    try {
      const m = await uploadMaterial(file, { title: title || file.name, description }, setProgress);
      toast.success("Archivo listo para compartir");
      setFile(null);
      setTitle("");
      setDescription("");
      if (fileRef.current) fileRef.current.value = "";
      onUploaded(m);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setProgress(null);
    }
  };

  return (
    <form onSubmit={submit} className="rounded-[1.5rem] border-2 border-dashed border-ink/15 bg-paper/60 p-5" data-testid="upload-box">
      <label className="flex cursor-pointer flex-col items-center justify-center gap-2 rounded-2xl bg-white px-4 py-6 text-center">
        <CloudUpload className="h-8 w-8 text-leaf-deep" />
        <span className="text-sm font-semibold">{file ? file.name : "Elegir PDF, video (MP4/MOV) o imagen"}</span>
        <span className="text-xs text-ink/60">{file ? `${(file.size / 1024 / 1024).toFixed(1)} MB` : hint || "Hasta 250 MB · se sube por partes"}</span>
        <input ref={fileRef} type="file" accept=".pdf,.mp4,.mov,.webm,.jpg,.jpeg,.png,.webp" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="upload-file" />
      </label>
      <div className="mt-3 grid gap-2 sm:grid-cols-2">
        <Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Título (ej. Mi video de invitación)" className="h-10 bg-white" data-testid="upload-title" />
        <Input value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Descripción corta (opcional)" className="h-10 bg-white" data-testid="upload-description" />
      </div>
      {progress !== null && <div className="mt-3 h-2 overflow-hidden rounded-full bg-ink/10"><div className="h-full bg-leaf transition-[width]" style={{ width: `${progress}%` }} data-testid="upload-progress" /></div>}
      <button type="submit" disabled={progress !== null} className="btn-ink mt-3 !px-5 !py-2.5 !text-xs disabled:opacity-60" data-testid="upload-submit">{progress !== null ? <Loader2 className="h-4 w-4 animate-spin" /> : <CloudUpload className="h-4 w-4" />} {progress !== null ? `Subiendo ${progress}%` : "Subir archivo"}</button>
    </form>
  );
};
